import React from 'react';
import { useDrag } from 'react-dnd';
import { Box, Button, Text } from 'grommet';
import { FormClose } from 'grommet-icons';
import { dragTypes } from './drag-utils';
import { groups } from './metrics';

const getBackground = groupType => {
  switch (groupType) {
    case groups.PARTNER:
      return 'rgb(0, 82, 204)';
    case groups.CAMPAIGN:
      return 'neutral-1';
    default:
      // neutral fallback so chips for any other group (e.g. hidden helper
      // metrics that appear as columns in older saved reports) stay legible.
      // The label text is white, so this must not be a light/white color.
      return 'dark-3';
  }
};

const AvailableField = ({ column, onRemove, width = '110px' }) => {
  const canRemove = typeof onRemove === 'function';

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: dragTypes.AVAILABLE_FIELD,
      item: column,
      collect: monitor => ({
        isDragging: monitor.isDragging()
      })
    }),
    [column]
  );

  return (
    <section
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
        paddingTop: '4px',
        paddingBottom: '4px',
        flexShrink: 0
      }}
    >
      <Box
        background={getBackground(column.group)}
        align='center'
        justify={canRemove ? 'between' : 'center'}
        width={width}
        height='50px'
        pad='small'
        round='small'
        direction='row'
        gap='xsmall'
        title={column.title}
      >
        <Box fill='horizontal'>
          <Text color='#ffffff' textAlign='center'>
            {column.name}
          </Text>
        </Box>

        {canRemove && (
          <Button
            icon={<FormClose />}
            plain
            onClick={() => {
              onRemove(column.name);
            }}
          />
        )}
      </Box>
    </section>
  );
};

AvailableField.displayName = 'AvailableField';

export default AvailableField;
